<h1 class="text-center !text-3xl !font-normal text-tertiary-900">
    Input technical data
</h1>
<h2 class="text-center !text-base !font-medium text-tertiary-900">
    Select the desired options below and enter your system information. For
    other requests, please use
    <a
        class="text-primary-700 hover:text-primary-800"
        [routerLink]="[getDashboardRoute()]"
        >Cevo</a
    >.
</h2>

<app-go-application-purpose-selection
    [applicationPurpose]="this.form.controls.applicationPurpose.value"
    [fccRegistrationNumber]="
        goApplicationRequestForm.controls.fccRegistrationNumber.value
    "
    [callSign]="goApplicationRequestForm.controls.callSign.value"
></app-go-application-purpose-selection>
<div class="text-right space-x-3 m-4">
    <button
        class="text-primary-700 hover:text-primary-800"
        (click)="expandAllPanels()"
    >
        Expand All
    </button>
    <button
        class="text-primary-700 hover:text-primary-800"
        (click)="collapseAllPanels()"
    >
        Collapse All
    </button>
</div>
<form [formGroup]="form" class="space-y-4">
    <!-- Bandwidth -->
    <mat-expansion-panel #frequencyTypeExpansionPanel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h1 [innerHTML]="getFrequencyTypeExpansionPanelTitle()"></h1>

                @if (isFrequencyTypeSectionInvalid()) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </mat-panel-title>

            <mat-panel-description>
                @if (
                    hasFrequencyTypeSelection &&
                    !frequencyTypeExpansionPanel.expanded
                ) {
                    {{ getFrequencyTypeExpansionPanelDescription() }}
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <app-go-segmented-toggle
            formControlName="frequencyType"
            [options]="frequencyTypeSegmentedToggleOptions"
        ></app-go-segmented-toggle>
    </mat-expansion-panel>

    <!-- Location Type -->
    <mat-expansion-panel #locationTypeExpansionPanel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h1 [innerHTML]="getLocationTypeExpansionPanelTitle()"></h1>

                @if (isLocationTypeSectionInvalid()) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </mat-panel-title>

            <mat-panel-description>
                @if (
                    hasLocationTypeSelection &&
                    !locationTypeExpansionPanel.expanded
                ) {
                    {{ getLocationTypeExpansionPanelDescription() }}
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <app-go-segmented-toggle
            formControlName="locationType"
            [options]="locationTypeSegmentedToggleOptions"
        ></app-go-segmented-toggle>
    </mat-expansion-panel>

    <!-- Station Class Information -->
    <mat-expansion-panel #stationClassTypeExpansionPanel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h1 [innerHTML]="getStationClassExpansionPanelTitle()"></h1>

                @if (isStationClassSectionInvalid()) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </mat-panel-title>

            <mat-panel-description>
                @if (
                    hasStationClassTypeSelection &&
                    !stationClassTypeExpansionPanel.expanded
                ) {
                    {{ getStationClassExpansionPanelDescription() }}
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="flex flex-col space-y-4">
            <app-go-segmented-toggle
                formControlName="stationClassType"
                [options]="stationClassTypeSegmentedToggleOptions"
            ></app-go-segmented-toggle>

            @if (shouldShowDataDirectionType()) {
                <app-go-segmented-toggle
                    formControlName="dataDirectionType"
                    [options]="dataDirectionTypeSegmentedToggleOptions"
                ></app-go-segmented-toggle>
            }
        </div>
    </mat-expansion-panel>

    <!-- Number of Frequencies -->
    <mat-expansion-panel #numberOfFrequenciesExpansionPanel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h1
                    [innerHTML]="getNumberOfFrequenciesExpansionPanelTitle()"
                ></h1>

                @if (isNumberOfFrequenciesSectionInvalid()) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </mat-panel-title>

            <mat-panel-description>
                @if (
                    hasNumberOfFrequenciesSelection &&
                    !numberOfFrequenciesExpansionPanel.expanded
                ) {
                    {{ getNumberOfFrequenciesExpansionPanelDescription() }}
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <app-go-segmented-toggle
            formControlName="numberOfFrequencies"
            [options]="numberOfFrequenciesSegmentedToggleOptions"
        ></app-go-segmented-toggle>
    </mat-expansion-panel>

    <!-- Coordinates -->
    <mat-expansion-panel
        #coordinatesExpansionPanel
        [style.overflow]="'visible'"
        [expanded]="true"
    >
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h1 [innerHTML]="getCoordinatesExpansionPanelTitle()"></h1>

                @if (isCoordinatesSectionInvalid()) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </mat-panel-title>

            <mat-panel-description>
                @if (
                    hasCoordinatesTypeSelection &&
                    !coordinatesExpansionPanel.expanded
                ) {
                    @if (
                        goCoordinatesType.ASR === coordinatesTypeControl.value
                    ) {
                        {{ getCoordinatesExpansionPanelDescriptionAsr() }}
                    }
                    @if (
                        goCoordinatesType.ASR !== coordinatesTypeControl.value
                    ) {
                        {{ getCoordinatesExpansionPanelDescription() }}
                    }
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <app-go-segmented-toggle
            formControlName="coordinatesType"
            [options]="coordinatesSegmentedToggleOptions"
        ></app-go-segmented-toggle>

        <div class="mt-4">
            @switch (coordinatesTypeControl.value) {
                @case (goCoordinatesType.ASR) {
                    @if (this.showAsrInvalidMsg) {
                        <p class="text-error-700 mb-2">
                            {{ goParametersValidationMessages.asrInvalid }}
                        </p>
                    }
                    <mat-form-field
                        appearance="outline"
                        class="w-full !-mb-[1.25em]"
                        color="primary"
                    >
                        <mat-label>FCC ASR Number</mat-label>
                        <input
                            title="FCC ASR Number"
                            matInput
                            formControlName="towerRegistrationNumber"
                            #towerRegistrationNumberInput
                            [imask]="
                                schedulesDAndHMaskConfig.towerRegistrationNumber
                            "
                        />
                    </mat-form-field>
                }
                @case (goCoordinatesType.LatitudeLongitude) {
                    <app-latitude-longitude-form
                        [latitudeControl]="latitudeControl"
                        [longitudeControl]="longitudeControl"
                        [compact]="true"
                    ></app-latitude-longitude-form>
                }

                @case (goCoordinatesType.Map) {
                    <app-go-map-picker
                        [start]="getExistingCoordinates()"
                        (coordsChange)="onMapCoordsChange($event)"
                    >
                    </app-go-map-picker>
                }
            }
        </div>
    </mat-expansion-panel>

    <!-- Antenna Height -->
    <mat-expansion-panel #antennaHeightExpansionPanel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h1 [innerHTML]="getAntennaHeightExpansionPanelTitle()"></h1>

                @if (isAntennaHeightUnitTypeSectionInvalid()) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </mat-panel-title>

            <mat-panel-description>
                @if (
                    (hasAntennaHeightUnitTypeSelection &&
                        !antennaHeightExpansionPanel.expanded) ||
                    isHeightToTipControlDisabled()
                ) {
                    {{ getAntennaHeightExpansionPanelDescription() }}
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="flex items-center space-x-2">
            <mat-form-field
                appearance="outline"
                class="w-[400px] !-mb-[1.25em]"
                color="primary"
            >
                <mat-label>Height from ground to tip</mat-label>
                <input
                    title="Antenna Height"
                    matInput
                    [imask]="schedulesDAndHMaskConfig.heightOfStructure"
                    formControlName="heightToTip"
                />
            </mat-form-field>

            <app-go-segmented-toggle
                class="mb-0.5 w-64"
                formControlName="antennaHeightUnitType"
                [options]="antennaHeightUnitTypeSegmentedToggleOptions"
            ></app-go-segmented-toggle>
        </div>
    </mat-expansion-panel>

    <!-- ERP -->
    <mat-expansion-panel #erpExpansionPanel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h1
                    [innerHTML]="getMinimumErpRequiredExpansionPanelTitle()"
                ></h1>
                <app-hover-tooltip
                    class="ml-2"
                    [message]="erpTooltip"
                ></app-hover-tooltip>

                @if (isMinimumErpRequiredSectionInvalid()) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </mat-panel-title>

            <mat-panel-description>
                @if (hasMinimumErpSelection && !erpExpansionPanel.expanded) {
                    {{ getMinimumErpRequiredExpansionPanelDescription() }}
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="flex items-center space-x-2">
            <mat-form-field
                appearance="outline"
                class="w-full !-mb-[1.25em]"
                color="primary"
            >
                <mat-label>Fixed ERP (Watts)</mat-label>
                <input
                    title="Fixed ERP (Watts)"
                    matInput
                    [imask]="frequencyMaskConfig.power"
                    formControlName="fixedErp"
                />
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="w-full !-mb-[1.25em]"
                color="primary"
            >
                <mat-label>Mobile ERP (Watts)</mat-label>
                <input
                    title="Mobile ERP (Watts)"
                    matInput
                    [imask]="frequencyMaskConfig.power"
                    formControlName="mobileErp"
                />
            </mat-form-field>
        </div>
    </mat-expansion-panel>

    <!-- Emission Designator -->
    <mat-expansion-panel #emissionDesignatorExpansionPanel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h1
                    [innerHTML]="getEmissionDesignatorExpansionPanelTitle()"
                ></h1>

                @if (isEmissionDesignatorSectionInvalid()) {
                    <img src="assets/svg/error_icon.svg" alt="Error Icon" />
                }
            </mat-panel-title>

            <mat-panel-description>
                @if (
                    hasEmissionDesignatorSelection &&
                    !emissionDesignatorExpansionPanel.expanded
                ) {
                    <span
                        [innerHTML]="
                            getEmissionDesignatorExpansionPanelDescription()
                        "
                    ></span>
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <app-go-segmented-toggle
            formControlName="emissionDesignatorPowerType"
            [allowMultipleSelections]="true"
            [options]="emissionDesignatorPowerTypeSegmentedToggleOptions"
        ></app-go-segmented-toggle>

        <div class="flex items-center my-2">
            <hr class="w-full border-tertiary-300 border-[0.5px]" />
            <p
                class="!m-0 text-center px-3 font-medium text-sm text-tertiary-600"
            >
                And
            </p>
            <hr class="w-full border-tertiary-300 border-[0.5px]" />
        </div>

        <app-go-segmented-toggle
            formControlName="emissionDesignatorInformationType"
            [options]="emissionDesignatorInformationTypeSegmentedToggleOptions"
        ></app-go-segmented-toggle>

        <p
            class="!m-0 pt-3 font-medium w-full text-center text-sm text-tertiary-600"
        >
            Including larger emissions limits availability of exclusive
            frequencies
        </p>
    </mat-expansion-panel>

    <p class="w-full text-center text-sm text-tertiary-900">
        <span class="text-error-700">Required Fields</span> Marked With
        <span class="text-error-700">*</span>
    </p>

    <p class="text-tertiary-900 text-sm">
        Additional information for EWA is welcome in the Comments field, after
        Cevo Go identifies frequencies.
    </p>
</form>
